// @flow
import React from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import navigation from 'app/redux/actions/navigation';
import api from 'utils/API';
import styles from './AuthorArchive.styles.js';
import CategoryArchiveItem from 'app/components/CategoryArchiveItem';
import AuthorAvatar from 'app/components/AuthorAvatar';
import Pagination from 'app/components/Pagination';

class AuthorArchive extends React.Component<Props> {
  unmounted = false;

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      author: {}
    };
  }

  listFill = (count = 30) => {
    return new Array(30).concat().fill({});
  }

  fetchPage = () => {
    const url = `/author/${this.props.authorSlug}`;
    const page = this.props.page || 1;
    const count = this.props.count || 20;
    const filledList = this.listFill(count);
    const data = {page, count, id: this.props.authorSlug};
    
    this.setState({list: filledList});

    api.post(url, data)
    .then(response => {
      if (this.unmounted) {
        return;
      }
      
      const data = response.data;
      const currentPage = data.pagination.page;
      const author = data.user || {};

      // Set navigation data
      const navigationData = {
        meta: {
          title: data.g_title,
          description: data.g_description,
          canonicalUrl: data.g_canonical_url,
          nextUrl: data.g_next_url,
          prevUrl: data.g_prev_url,
          ogTitle: data.og_title,
          ogType: data.og_type,
          ogDescription: data.og_description,
          ogUrl: data.og_url,
          ogArticleSsection: data.og_article_section,
          ogSiteName: data.og_site_name,
          ogImage: data.og_image
        }
      };
      this.props.dispatch(navigation(navigationData));
      //

      this.setState({
        author,
        currentPage,
        perPage: data.pagination.count,
        totalItems: data.pagination.total,
        list: data.list || [],
      });
    }); 
  }

  componentDidMount() {
    if (this.props.authorSlug) {
      this.fetchPage();
    }
  }

  componentDidUpdate(prevProps, PrevState) {
    if (prevProps.page !== this.props.page || prevProps.authorSlug !== this.props.authorSlug) {
      this.fetchPage();
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    const {classes} = this.props;
    // console.log(this.props)
    return (
      <React.Fragment>
        <AuthorAvatar
          name={this.state.author.name}
          slug={this.state.author.uname}
          image={this.state.author.image}
          className={classes.avatar}
        />
        {this.state.list && this.state.list.map((newsItem, index) => {
          const category = (newsItem.category && newsItem.category[0]) || {};
          const key = newsItem.name || index;
          return (
            <CategoryArchiveItem
              key={key}
              data={newsItem}
              category={category}
              className={classes.card}
            />
          );
        })}
        <Pagination
          totalItems={this.state.totalItems}
          perPage={this.state.perPage}
          current={this.state.currentPage}
          urlTemplate={`/author/:author/page/:page`}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return ({
    pagination: state.pagination,
    navigation: state.navigation
})};

const Component = connect(mapStateToProps)(withStyles(styles)(AuthorArchive));
export {Component as AuthorArchive};
export default Component;